import { useMutation, useQueryClient } from "@tanstack/react-query";

import { type SetStageScheduleInput, setStageSchedule } from "@/adapters/api";

export function useSetSchedule(constructionId: string | undefined) {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: ({
			stageId,
			input,
		}: {
			stageId: string;
			input: SetStageScheduleInput;
		}) => {
			if (!constructionId) throw new Error("missing construction");
			return setStageSchedule(constructionId, stageId, input);
		},
		onSuccess: (_schedule, { stageId }) => {
			queryClient.invalidateQueries({
				queryKey: ["schedules", constructionId],
			});
			queryClient.invalidateQueries({
				queryKey: ["schedule", constructionId, stageId],
			});
		},
	});
}
